import { IState } from '../../store';
import { getParent } from '../../utils/offer_helpers';

export function getOfferParent(state: IState) {
  return getParent(state.offerData);
}
